const lightOrDark = (color: string): 'light' | 'dark' => {
  let r: number
  let g: number
  let b: number

  if (color.match(/^rgb/)) {
    // @ts-expect-error
    ;[r, g, b] = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    )
  } else {
    const colorHex = Number(
      color.length >= 5
        ? `0x${color.slice(1)}`
        : `0x${color.slice(1).replace(/./g, '$&$&')}`
    )

    r = colorHex >> 16
    g = (colorHex >> 8) & 255
    b = colorHex & 255
  }

  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

  return hsp > 205 ? 'light' : 'dark'
}

export default lightOrDark
